module.exports = __webpack_public_path__ + "static/img/alipay-geren.02bc2a57.png";